/*
 * This hook will return product variant that has provided attribute values
 */
export const useVariationByAttributeValues = (product = {}, variation) => {
    const {variants = []} = product

    return variants.find((item) => {
        const variationValues = item?.variationValues || {}
        return Object.entries(variation).every(([key, value]) => variationValues[key] === value)
    })
}
